<template>
    <el-button type="danger" :size="size" :loading="loadingSure" :disabled="disabled" @click="submit">
        <span v-html="buttonTxt"/>
    </el-button>
</template>

<script>

    export default {
        name: 'ButtonSubmit',
        props: {
            buttonTxt: {
                type: String,
                default: '确定'
            },
            size: {
                type: String,
                default: 'default'
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loadingSure: false
            }
        },
        mounted() {
        },
        methods: {
            submit() {
                if (this.loadingSure) {
                    this.$notify({
                        title: '警告',
                        message: '操作频繁，请稍后重试。',
                        type: 'warning'
                    })
                    return false
                }
                this.loadingSure = true
                setTimeout(() => {
                    this.loadingSure = false
                }, 1500)
            }
        }
    }
</script>

<style scoped>
</style>
